import { PatientClinicalEvents } from '~/analytics/patientEvents';
import {
  OrderEquipScaleFrom,
  WarningTypes,
} from '~/lib/constants/patients.constants';

export const PROCEED_WITH_ORDER_EVENT_BY_WARNING: Record<
  Exclude<OrderEquipScaleFrom, OrderEquipScaleFrom.NONE>,
  Record<WarningTypes, PatientClinicalEvents>
> = {
  [OrderEquipScaleFrom.BANNER]: {
    [WarningTypes.UNDER_18]:
      PatientClinicalEvents.bannerWarningConfirmationModalUnderEighteenProceedWithOrderClicked,
    [WarningTypes.NO_RECENT_WEIGHT]:
      PatientClinicalEvents.bannerWarningConfirmationModalNoWeightDataProceedWithOrderClicked,
    [WarningTypes.EXCEEDS_SCALE_LIMIT]:
      PatientClinicalEvents.bannerWarningConfirmationModalExceedsWeightProceedWithOrderClicked,
  },
  [OrderEquipScaleFrom.DEVICE]: {
    [WarningTypes.UNDER_18]:
      PatientClinicalEvents.deviceWarningConfirmationModalUnderEighteenProceedWithOrderClicked,
    [WarningTypes.NO_RECENT_WEIGHT]:
      PatientClinicalEvents.deviceWarningConfirmationModalNoWeightDataProceedWithOrderClicked,
    [WarningTypes.EXCEEDS_SCALE_LIMIT]:
      PatientClinicalEvents.deviceWarningConfirmationModalExceedsWeightProceedWithOrderClicked,
  },
};
